// Company mapping API (internal staff).
import { api } from './client.js';

export const fetchCompanies = (store) =>
  api.get('/companies', { params: store ? { store } : {} }).then((r) => r.data.companies);

export const syncCompanies = (store) =>
  api.post('/companies/sync', { store }).then((r) => r.data);

export const fetchCompanyDetail = (store, shopifyCompanyId) =>
  api.get('/companies/detail', { params: { store, shopifyCompanyId } }).then((r) => r.data);

export const provisionClient = (body) =>
  api.post('/companies/provision-client', body).then((r) => r.data);

export const provisionRep = (body) =>
  api.post('/companies/provision-rep', body).then((r) => r.data);

// Create a brand-new B2B company (staff). `fetchCatalogs` populates the pricing picker.
export const fetchCatalogs = (store) =>
  api.get('/companies/catalogs', { params: { store } }).then((r) => r.data.catalogs);
export const createCompany = (body) => api.post('/companies/create', body).then((r) => r.data);

// Team & access (staff + rep logins).
export const fetchTeam = () => api.get('/companies/team').then((r) => r.data.team);
export const provisionStaff = (body) => api.post('/companies/provision-staff', body).then((r) => r.data);
export const setUserActive = (userId, isActive) =>
  api.post('/companies/user-active', { userId, isActive }).then((r) => r.data);
export const setUserAccess = (userId, patch) =>
  api.post('/companies/user-access', { userId, ...patch }).then((r) => r.data);
export const resendInvite = (userId) => api.post('/companies/resend-invite', { userId }).then((r) => r.data);
export const bulkInvite = (companyIds) => api.post('/companies/bulk-invite', { companyIds }).then((r) => r.data);

export const assignRep = (body) => api.post('/companies/assign-rep', body).then((r) => r.data);

export const setCompanyTrusted = (companyId, isTrusted) =>
  api.post('/companies/trusted', { companyId, isTrusted }).then((r) => r.data);

export const fetchAssignableOwners = () => api.get('/companies/assignable-owners').then((r) => r.data);
export const setCompanyOwners = (companyId, { repUserId, csUserId }) =>
  api.post('/companies/owners', { companyId, repUserId, csUserId }).then((r) => r.data);
export const backfillSpend = () => api.post('/companies/backfill-spend').then((r) => r.data);
export const setContactPrimary = (companyId, contactId) =>
  api.post('/companies/contact-primary', { companyId, contactId }).then((r) => r.data);

export const bulkSetActive = (companyIds, isActive) =>
  api.post('/companies/bulk-active', { companyIds, isActive }).then((r) => r.data);
export const bulkSetOwners = (companyIds, owners) =>
  api.post('/companies/bulk-owners', { companyIds, ...owners }).then((r) => r.data);

export const setCompanyPaymentTerms = (companyId, terms) =>
  api.post('/companies/payment-terms', { companyId, terms }).then((r) => r.data);
export const setCompanyPaymentMethod = (companyId, method) =>
  api.post('/companies/payment-method', { companyId, method }).then((r) => r.data);
export const setCompanyActive = (companyId, isActive) =>
  api.post('/companies/active', { companyId, isActive }).then((r) => r.data);

export const fetchTimeline = (companyId) =>
  api.get('/companies/timeline', { params: { companyId } }).then((r) => r.data);

// Customs credential (government ID some destinations require, e.g. China's Resident ID number).
// The read is MASKED — it returns only the last 4 digits, never the value.
export const fetchShippingCredential = (store, companyLocationId) =>
  api.get('/companies/shipping-credential', { params: { store, companyLocationId } }).then((r) => r.data);
// value: null clears it.
export const setShippingCredential = (body) =>
  api.post('/companies/shipping-credential', body).then((r) => r.data);

// PDF endpoints (open as links).
export const companyStatementUrl = (companyId) => `/api/companies/statement.pdf?companyId=${companyId}`;
export const myStatementUrl = () => `/api/me/statement.pdf`;

// Every contact on a client, with billing/head-office flags (staff).
export const fetchCompanyContacts = (companyId) =>
  api.get('/companies/contacts', { params: { companyId } }).then((r) => r.data.contacts);

// Point ALL of a client's finance mail at one plain address (an AP inbox needs no login).
// Pass null for per-location routing.
export const setBillingEmail = (companyId, email, name) =>
  api.post('/companies/billing-email', { companyId, email, name }).then((r) => r.data);

// Same, but chosen from an existing login (records the link as well as the address).
export const setBillingContact = (companyId, contactId) =>
  api.post('/companies/billing-contact', { companyId, contactId }).then((r) => r.data);

// Let one login place orders for every location of its company.
export const setContactAllLocations = (contactId, allLocations) =>
  api.post('/companies/contact-all-locations', { contactId, allLocations }).then((r) => r.data);
// Credit control: manual hold + optional credit limit.
export const setCompanyCredit = (body) => api.post('/companies/credit', body).then((r) => r.data.credit);
